module.exports = __webpack_public_path__ + "static/media/ceres-logo-red.4ec829ff.svg";